
import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

interface SubscriptionSearchBarProps {
  searchQuery: string;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const SubscriptionSearchBar: React.FC<SubscriptionSearchBarProps> = ({
  searchQuery,
  onSearch
}) => {
  return (
    <div className="w-full max-w-xs">
      <div className="relative">
        <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input 
          placeholder="Search subscriptions..." 
          className="pl-8"
          value={searchQuery}
          onChange={onSearch}
        />
      </div>
    </div>
  );
};

export default SubscriptionSearchBar;
